module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "animated fadeIn",
    attrs: {
      "id": "particles-js"
    }
  }), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animation.ready),
      expression: "animation.ready"
    }],
    staticClass: "hero is-fullheight has-text-centered"
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-spaced is-size-2 animated fadeInLeft"
  }, [_vm._v("\n          Vladimir Avgustov\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle is-size-4 animated fadeInRight"
  }, [_vm._v("\n          Ruby on Rails | Full Stack Web Developer\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "social is-size-2 animated fadeInLeft"
  }, [_c('a', {
    attrs: {
      "id": "github",
      "title": "GitHub",
      "href": "https://github.com/vavgustov",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "linkedin",
      "title": "LinkedIn",
      "href": "https://www.linkedin.com/in/vavgustov",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "email",
      "title": "Email",
      "href": "mailto:vavgustov@yandex.ru"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-703a012c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 7
// module chunks = 1